<script setup>
import SurveyTable from '@/views/survey/SurveyTable2.vue'

// import SurveyCompletionDashboard from '@/views/survey/dashboard/SurveyCompletionDashboard.vue'
// import SurveyResponseAnalytics from '@/views/survey/dashboard/SurveyResponseAnalytics.vue'

definePage({
  meta: {
    name: 'survey-entry-employee',
    subject: 'survey.menu',
    action: 'survey_entry_employee',
  },  
})
</script>

<template>
  <div>
    <VRow>
      <!-- page title -->
      <VCol cols="12">
        <span class="text-h3 font-weight-bold text-primary text-capitalize">
          Employee Survey
        </span>
        <p class="text-body-2">
          Manage & analyze employee's Survey
        </p>
      </VCol>
      <!--
        <VCol cols="6">
        <SurveyCompletionDashboard />
        </VCol>
        <VCol cols="6">
        <SurveyResponseAnalytics />
        </VCol> 
      -->
    </VRow>
    <SurveyTable
      class="mt-3"
      page-type="Employee"
    />
  </div>
</template>
